import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addToCart: {
    id: 'universals.add.to.cart',
    defaultMessage: 'Do košíku',
  },
  buyButtonError: {
    id: 'pd.buyButton.error',
    defaultMessage: 'Chyba při přidání do košíku',
  },
  buyButtonLoading: {
    id: 'pd.buyButton.loading',
    defaultMessage: 'Přidávání do košíku, prosím čekejte',
  },
});
